import React, { ReactNode } from "react";

import styled from "styled-components";

import { AttributeValueInputProps } from "..";
import { TIMESTAMP_DISPLAY_FORMAT, TIMESTAMP_SAVE_FORMAT } from "../../../../constants";
import MomentFormItemPopper from "../../MomentFormItemPopper";
import { TimeStampPicker } from "../../MomentFormItemPopper/DateTimePickers";

const Generated = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 28px;
  justify-content: center;
`;

export default function TimestampInput({
  sourceName,
  sourceType,
  value,
  form,
  fieldOptions,
  displayNullPlaceholder,
  disabled,
  generated,
  preventOverflow,
  onChange,
  onFocus,
  onBlur
}: AttributeValueInputProps) {
  if (generated) {
    return (
      <Generated>
        <em>This field will be set automatically.</em>
      </Generated>
    );
  }

  const decorator = form
    ? form.getFieldDecorator(sourceName, {
        initialValue: value,
        ...fieldOptions
      })
    : (comp: ReactNode) => comp;

  return (
    <>
      {decorator(
        <MomentFormItemPopper
          sourceName={sourceName}
          sourceType={sourceType}
          fieldOptions={fieldOptions}
          onChange={onChange ? onChange : () => null}
          getFieldValue={form ? form.getFieldValue : () => null}
          displayNullPlaceholder={displayNullPlaceholder}
          disabled={disabled}
          preventOverflow={preventOverflow}
          displayFormat={TIMESTAMP_DISPLAY_FORMAT}
          saveFormat={TIMESTAMP_SAVE_FORMAT}
          PopoverPicker={TimeStampPicker}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}
    </>
  );
}
